var _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path0, _mask6, _path1, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_606_4794",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: -0.47754,
    width: 13,
    height: 22,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: -0.47754,
    width: 13,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3123 0.86537C14.7592 1.34434 12.3238 2.31609 10.1423 3.72633L21 20.5225L17.3123 0.86537Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3123 0.86537C14.7592 1.34434 12.3238 2.31609 10.1423 3.72633L21 20.5225L17.3123 0.86537Z",
    fill: "#AFD3E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3123 0.86537C14.7592 1.34434 12.3238 2.31609 10.1423 3.72633L21 20.5225L17.3123 0.86537Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-1-outside-1_606_4794)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-2_606_4794",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: -0.47754,
    width: 16,
    height: 22,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 16,
    y: -0.47754,
    width: 16,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2796 0.871546C22.0543 -0.0324351 26.9948 0.832941 31.1781 3.30598L21 20.5225L17.2796 0.871546Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2796 0.871546C22.0543 -0.0324351 26.9948 0.832941 31.1781 3.30598L21 20.5225L17.2796 0.871546Z",
    fill: "#F6AE99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2796 0.871546C22.0543 -0.0324351 26.9948 0.832941 31.1781 3.30598L21 20.5225L17.2796 0.871546Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-2-outside-2_606_4794)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-3_606_4794",
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 2.52246,
    width: 22,
    height: 21,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20,
    y: 2.52246,
    width: 22,
    height: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9818 3.19145C34.4155 5.16912 37.1844 8.12222 38.9371 11.6761C40.6899 15.2299 41.3474 19.2243 40.8263 23.1525L21 20.5225L30.9818 3.19145Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9818 3.19145C34.4155 5.16912 37.1844 8.12222 38.9371 11.6761C40.6899 15.2299 41.3474 19.2243 40.8263 23.1525L21 20.5225L30.9818 3.19145Z",
    fill: "#B97A95"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9818 3.19145C34.4155 5.16912 37.1844 8.12222 38.9371 11.6761C40.6899 15.2299 41.3474 19.2243 40.8263 23.1525L21 20.5225L30.9818 3.19145Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-3-outside-3_606_4794)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-4_606_4794",
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 19.5225,
    width: 22,
    height: 18,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20,
    y: 19.5225,
    width: 22,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8318 23.1105C40.1455 28.3702 37.3978 33.1419 33.1932 36.3757L21 20.5225L40.8318 23.1105Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8318 23.1105C40.1455 28.3702 37.3978 33.1419 33.1932 36.3757L21 20.5225L40.8318 23.1105Z",
    fill: "#94D4D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8318 23.1105C40.1455 28.3702 37.3978 33.1419 33.1932 36.3757L21 20.5225L40.8318 23.1105Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-4-outside-4_606_4794)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-5_606_4794",
    maskUnits: "userSpaceOnUse",
    x: -0.00000179061,
    y: 19.5225,
    width: 34,
    height: 22,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.00000179061,
    y: 19.5225,
    width: 34,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3615 36.2448C30.3738 38.5939 26.7786 40.043 22.9969 40.4225C19.2153 40.802 15.4038 40.0961 12.0089 38.3875C8.61399 36.6789 5.77619 34.0384 3.82786 30.7751C1.87953 27.5119 0.901347 23.7611 1.00786 19.9619L21 20.5225L33.3615 36.2448Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3615 36.2448C30.3738 38.5939 26.7786 40.043 22.9969 40.4225C19.2153 40.802 15.4038 40.0961 12.0089 38.3875C8.61399 36.6789 5.77619 34.0384 3.82786 30.7751C1.87953 27.5119 0.901347 23.7611 1.00786 19.9619L21 20.5225L33.3615 36.2448Z",
    fill: "#FF7A5C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3615 36.2448C30.3738 38.5939 26.7786 40.043 22.9969 40.4225C19.2153 40.802 15.4038 40.0961 12.0089 38.3875C8.61399 36.6789 5.77619 34.0384 3.82786 30.7751C1.87953 27.5119 0.901347 23.7611 1.00786 19.9619L21 20.5225L33.3615 36.2448Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-5-outside-5_606_4794)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-6_606_4794",
    maskUnits: "userSpaceOnUse",
    x: -9.17144e-7,
    y: 2.52246,
    width: 22,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -9.17144e-7,
    y: 2.52246,
    width: 22,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4015 3.56158C7.54138 5.3488 5.17968 7.83027 3.53601 10.7752C1.89233 13.7202 1.02008 17.0329 1.00035 20.4055L21 20.5225L10.4015 3.56158Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4015 3.56158C7.54138 5.3488 5.17968 7.83027 3.53601 10.7752C1.89233 13.7202 1.02008 17.0329 1.00035 20.4055L21 20.5225L10.4015 3.56158Z",
    fill: "#F5CC3B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4015 3.56158C7.54138 5.3488 5.17968 7.83027 3.53601 10.7752C1.89233 13.7202 1.02008 17.0329 1.00035 20.4055L21 20.5225L10.4015 3.56158Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-6-outside-6_606_4794)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.59766C13.64 6.59766 7.66669 12.571 7.66669 19.931C7.66669 27.291 13.64 33.2643 21 33.2643C28.36 33.2643 34.3334 27.291 34.3334 19.931C34.3334 12.571 28.36 6.59766 21 6.59766ZM22.3334 26.5977H19.6667V23.931H22.3334V26.5977ZM22.3334 21.2643H19.6667V13.2643H22.3334V21.2643Z",
    fill: "#323232"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 20.5225C36.75 29.2209 29.6985 36.2725 21 36.2725C12.3015 36.2725 5.25 29.2209 5.25 20.5225C5.25 11.824 12.3015 4.77246 21 4.77246C29.6985 4.77246 36.75 11.824 36.75 20.5225Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9867 7.18945C13.6267 7.18945 7.66669 13.1628 7.66669 20.5228C7.66669 27.8828 13.6267 33.8561 20.9867 33.8561C28.36 33.8561 34.3334 27.8828 34.3334 20.5228C34.3334 13.1628 28.36 7.18945 20.9867 7.18945ZM21 31.1895C15.1067 31.1895 10.3334 26.4161 10.3334 20.5228C10.3334 14.6295 15.1067 9.85612 21 9.85612C26.8934 9.85612 31.6667 14.6295 31.6667 20.5228C31.6667 26.4161 26.8934 31.1895 21 31.1895ZM19.6667 24.5228H22.3334V27.1895H19.6667V24.5228ZM19.6667 13.8561H22.3334V21.8561H19.6667V13.8561Z",
    fill: "#BBBBBB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImg);
export default __webpack_public_path__ + "static/media/ErrorImg.016cf827703eddc91d655297801cf7ca.svg";
export { ForwardRef as ReactComponent };